import { Check } from 'lucide-react';

// The Content Guide's §10 pre-publish checklist, shown next to the approve action.
// Editorial guidance the author confirms by hand — not enforced by the server.
const CHECKLIST = [
  'One topic only, 300–800 words.',
  'Metadata complete: title, tags (with synonyms), visibility, owner, questions.',
  'Reads correctly on its own, with no references to other articles or sections.',
  'Headings phrased as real customer questions.',
  'Neutral, factual tone — no marketing language.',
  'No prices, stock, discounts, or full ingredient lists.',
  'Cautions and escalation triggers stated explicitly.',
  'No medical claims or diagnoses.',
  'Product line names match the shop exactly.',
  'Fact-checked by the KB owner.',
];

export function PrePublishChecklist() {
  return (
    <div className="space-y-2 rounded-md border p-4">
      <p className="text-sm font-medium">Pre-publish checklist</p>
      <p className="text-xs text-[var(--color-muted-foreground)]">
        Confirm every line before approving — the agent uses only approved articles.
      </p>
      <ul className="space-y-1.5 text-sm">
        {CHECKLIST.map((item) => (
          <li key={item} className="flex items-start gap-2">
            <Check className="mt-0.5 size-4 shrink-0 text-[var(--color-muted-foreground)]" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
